/**
 * Shared breakpoints for the tenant app.
 *
 * WHY A SHARED CONSTANT rather than a media query typed in each file: the app had exactly
 * ONE width media query in it before 2026-09-08, so every surface needs adding at once —
 * and a phone layout that changes at a different width per screen reads as broken rather
 * than as responsive.
 *
 * 640px is the knee for this app, not a guess at device sizes: below it a two-column
 * toolbar and a data table cannot both be legible, so that is where the layout has to
 * change shape rather than merely shrink.
 */
export const MOBILE = '@media (max-width: 640px)';

/** Tablet and below — where wide toolbars start wrapping but tables stay tabular. */
export const NARROW = '@media (max-width: 1024px)';

/**
 * The flexbox fix that makes every `overflow-x: auto` in this app actually work.
 *
 * 🔥 THE BUG THIS EXISTS FOR. The report tables already had `overflowX: 'auto'`, yet on a
 * phone the whole PAGE went wide and content ran off the screen. A flex item defaults to
 * `min-width: auto`, so a flex child sized by a wide table REFUSES TO SHRINK below its
 * content — the scroll container therefore never becomes narrower than the table, and
 * there is nothing to scroll: the overflow lands on the document instead.
 *
 * Every ancestor between the page and a scroller needs this, which is why it is a named
 * constant and not a one-off. `minWidth: 0` is the fix; `maxWidth: '100%'` stops a wide
 * grid child doing the same thing.
 */
export const SHRINKABLE = { minWidth: 0, maxWidth: '100%' } as const;
